export class PSAcuerdoPosteriorModel {
    idPs: number = 0;
    tipo: number = -1;
    tipoLabel: string;
    fecha: Date = new Date();
    detalle: string = '';
    interlocutorCliente: string = '';
    interlocutorValtecsa: string = '';
}